<template>
  <!-- 竞品产品及实销 -->
  <div class="table_container">
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 我司车型 -->
      <el-table-column label="我司车型" align="center">
        <!-- 车型 -->
        <el-table-column
          prop="mineCarModel"
          label="车型"
          min-width="90px"
          align="center"
          class-name="disabled_column"
        />
        <!-- 截止查询年累计实销 -->
        <el-table-column
          prop="totalShixiao"
          :label="`截止${queryParams.years}年累计实销`"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'totalShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.totalShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <div v-else>
              {{ scope.row.totalShixiao }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 竞品 -->
      <el-table-column label="竞品" align="center">
        <!-- 品牌 -->
        <el-table-column
          prop="competitionBrand"
          label="品牌"
          min-width="90px"
          align="center"
          class-name="disabled_column"
        />
        <!-- 类别 -->
        <el-table-column
          prop="competitionType"
          label="类别"
          min-width="90px"
          align="center"
          class-name="disabled_column"
        />
        <!-- 车型 -->
        <el-table-column
          prop="competitionCarModel"
          label="车型"
          min-width="90px"
          align="center"
          class-name="disabled_column"
        />
      </el-table-column>
      <!-- 查询年竞品终端实销 -->
      <el-table-column
        :label="`${queryParams.years}年竞品终端实销`"
        align="center"
      >
        <!-- 实销 -->
        <el-table-column
          v-for="(item, index) in monthList"
          :key="index"
          :prop="item.shixiaoField"
          :label="item.month"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                editField === item.shixiaoField && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row[item.shixiaoField]"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <div v-else>
              {{ scope.row[item.shixiaoField] }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 合计 -->
      <el-table-column
        prop="total"
        label="合计"
        min-width="90px"
        align="center"
        class-name="total_column"
      >
        <template slot-scope="scope">
          {{ getColumnTotal(scope.row, "total", "shixiaoField") }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateCompetitiveSalesApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1, // 编辑行索引
      monthList: [
        {
          month: "1月",
          shixiaoField: "oneShixiao"
        },
        {
          month: "2月",
          shixiaoField: "twoShixiao"
        },
        {
          month: "3月",
          shixiaoField: "threeShixiao"
        },
        {
          month: "4月",
          shixiaoField: "fourShixiao"
        },
        {
          month: "5月",
          shixiaoField: "fiveShixiao"
        },
        {
          month: "6月",
          shixiaoField: "sixShixiao"
        },
        {
          month: "7月",
          shixiaoField: "sevenShixiao"
        },
        {
          month: "8月",
          shixiaoField: "eightShixiao"
        },
        {
          month: "9月",
          shixiaoField: "nineShixiao"
        },
        {
          month: "10月",
          shixiaoField: "tenShixiao"
        },
        {
          month: "11月",
          shixiaoField: "elevenShixiao"
        },
        {
          month: "12月",
          shixiaoField: "twelveShixiao"
        }
      ] // 月度
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 获取当前行合计
    getColumnTotal(row, totalField, field) {
      let total = 0;
      this.monthList.forEach(item => {
        const value = Number(row[item[field]]);
        if (!isNaN(value)) {
          total += value;
        }
      });
      row[totalField] = total;
      return total;
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: this.tableData
        };
        const res = await addOrUpdateCompetitiveSalesApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
